// if($('#add-cart-note-gift').length > 0){
//   // console.log("hola");
//   $("#add-cart-note-gift").change(function() {
//     if(this.checked) {
//         //Do stuff
//       console.log("hola");
//       $('.cart__note field').show();
//     }
// });
// }
  /* quitar tag h1 de la modal de la aplicación de guía de tallas */
  // function transformTag(tagIdOrElem, tagType){
  //   console.log("test");
  //   var elem = (tagIdOrElem instanceof HTMLElement) ? tagIdOrElem : document.getElementById(tagIdOrElem);
  //   if(!elem || !(elem instanceof HTMLElement))return;
  //   var children = elem.childNodes;
  //   var parent = elem.parentNode;
  //   var newNode = document.createElement(tagType||"span");
  //   for(var a=0;a<elem.attributes.length;a++){
  //       newNode.setAttribute(elem.attributes[a].nodeName, elem.attributes[a].value);
  //   }
  //   for(var i= 0,clen=children.length;i<clen;i++){
  //       newNode.appendChild(children[0]); //0...always point to the first non-moved element
  //   }
  //   newNode.style.cssText = elem.style.cssText;
  //   parent.replaceChild(newNode,elem);
  //   console.log("test");
  // }
  // transformTag(document.querySelector('#ccpops-popup__recommendation-size-result'), 'div');
// document.addEventListener("DOMContentLoaded", function(event) {
//   transformTag(document.querySelector('#ccpops-popup__recommendation-size-result'), 'div');
// });
// if(document.getElementsByClassName('product-grid').length > 0){
	
// 		// $( "<div class='category-label-shop'><p>SS23 HINT</p></div>" ).insertBefore( "li.post-23163" );
// if(document.getElementsByClassName('collection-all-accessories').length > 0){
//   // $( "<div class='category-label-shop'></p></div>" ).insertBefore( "li.post-23163" );
//   // document.innerHtml("<div class='category-label-shop'></div>");
//   // document.getElementsByClassName('lv-prod-7857830658256').parentElement.insertBefore("keyke");
//     var my_elem = document.getElementsByClassName('lv-prod-7857830658256').parentElement;  
//     var separator = document.createElement('div');
//       separator.className = 'asterisk';  
  
//     // my_elem.insertBefore(separator, my_elem);
//   // document.getElementsByClassName('lv-prod-7857830658256').parentElement.insertAdjacentElement("beforebegin", separator);
//   // document.querySelector( "<div class='category-label-shop'></div>" ).insertBefore( document.getElementsByClassName('lv-prod-7857830658256').parentElement );
// }
//   console.log("hola key key" );
//   const child = document.getElementsByClassName('lv-prod-7857830658256');

// const parentWithClass = child.closest('.parent');
//   console.log(child.closest(".grid__item"));
// }/* Fin titulos categoria new-in*/
(() => {
  const drawer = document.getElementById("menu-drawer");
  if (!drawer) return;

  drawer.querySelectorAll("li > a").forEach(a => {
    if (a.textContent.trim().includes("lv-nav-sp")) {
      const li = a.closest("li");
      if (!li) return;

      li.classList.add("lv-nav-spacer");
      li.style.display = "none";
    }
  });
})();